import type { CommandAck } from './contract'

export type RealtimeStatus =
  | 'idle'
  | 'connecting'
  | 'connected'
  | 'disconnected'
  | 'error'
  /** Servidor recusou por permissão: o FE cai para polling. */
  | 'forbidden'

export interface RealtimeConnectOptions {
  url: string
  /** Lido a cada (re)conexão, para usar sempre o token renovado. */
  getToken: () => string | null
  /** Token expirado no handshake/servidor: renovar e reconectar. */
  onAuthExpired: () => Promise<void>
}

/**
 * Transporte trocável: Socket.IO em produção, memória em mock/testes.
 * Recebe nomes de evento "crus" (strings do contrato).
 */
export interface RealtimeTransport {
  connect(options: RealtimeConnectOptions): void
  disconnect(): void
  on(event: string, handler: (payload: unknown) => void): () => void
  onStatus(listener: (status: RealtimeStatus) => void): () => void
  /** Comando com ack (subscribe/unsubscribe/whoami). */
  command(name: string, payload?: unknown): Promise<CommandAck>
}

export class StatusEmitter {
  private listeners = new Set<(status: RealtimeStatus) => void>()
  status: RealtimeStatus = 'idle'

  set(status: RealtimeStatus) {
    this.status = status
    this.listeners.forEach((listener) => listener(status))
  }

  subscribe(listener: (status: RealtimeStatus) => void) {
    this.listeners.add(listener)
    listener(this.status)
    return () => {
      this.listeners.delete(listener)
    }
  }
}
